import MKAD from './coordinates/Moscow/mkad.json';

export default {
    regionCode: 'moscow',
    serviceAreas: [
        {
            id: 'moscow-1',
            include: [
                {
                    name: 'МКАД',
                    type: 'polygon',
                    coordinates: MKAD,
                }
            ]
        },
        {
            id: 'moscow-2',
            include: [
                {
                    name: 'МКАД (расстояние 5км)',
                    type: 'polygon',
                    distance: true,
                    maxDistance: 5,
                    coordinates: MKAD,
                }
            ]
        },
        {
            id: 'moscow-3',
            include: [
                {
                    name: 'МКАД (расстояние 10км)',
                    type: 'polygon',
                    distance: true,
                    maxDistance: 10,
                    coordinates: MKAD,
                }
            ]
        },
        {
            id: 'moscow-4',
            include: [
                {
                    name: 'МКАД (расстояние 15км)',
                    type: 'polygon',
                    distance: true,
                    maxDistance: 15,
                    coordinates: MKAD,
                }
            ]
        },
        {
            id: 'moscow-5',
            include: [
                {
                    name: 'МКАД (расстояние 30км)',
                    type: 'polygon',
                    distance: true,
                    maxDistance: 30,
                    coordinates: MKAD,
                }
            ]
        },
        {
            id: 'moscow-6',
            include: [
                {
                    name: 'МКАД (расстояние 50км)',
                    type: 'polygon',
                    distance: true,
                    maxDistance: 50,
                    coordinates: MKAD,
                }
            ]
        },
    ]
};
